import { FormControl, InputLabel, Select, MenuItem, InputAdornment } from '@mui/material';
import { People } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { RESERVATION_CONSTRAINTS } from '@/types';

interface PeopleSelectorProps {
  value: number;
  onChange: (people: number) => void;
  label?: string;
  disabled?: boolean;
}

export function PeopleSelector({
  value,
  onChange,
  label,
  disabled = false,
}: PeopleSelectorProps) {
  const { t } = useTranslation();
  const displayLabel = label ?? t('peopleSelector.label');

  const options = Array.from(
    { length: RESERVATION_CONSTRAINTS.MAX_PEOPLE - RESERVATION_CONSTRAINTS.MIN_PEOPLE + 1 },
    (_, i) => i + RESERVATION_CONSTRAINTS.MIN_PEOPLE
  );

  return (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel>{displayLabel}</InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        label={displayLabel}
        startAdornment={
          <InputAdornment position="start">
            <People />
          </InputAdornment>
        }
      >
        {options.map((num) => (
          <MenuItem key={num} value={num}>
            {t('peopleSelector.person', { count: num })}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
